export default "__VITE_ASSET__4449283d__"